
import React from 'react';

export const ResetPasswordHeader: React.FC = () => {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold">Reset Your Password</h1>
      <p className="mt-2 text-muted-foreground">
        Enter your new password below
      </p>
    </div>
  );
};
